export default "__VITE_ASSET__CCoTK9z6__"